// chakra imports
import { Box, Flex, Stack } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import SidebarCard from "components/sidebar/components/SidebarCard";
import React from "react";
import { SidebarLinks } from "./Links";

// FUNCTIONS

function SidebarContent(props) {
  const { routes, activeId } = props;
  // SIDEBAR
  return (
    <Flex
      direction="column"
      height="100vh"
      pt="25px"
      px="16px"
      borderRadius="30px"
    >
      {/* <Brand /> */}
      <Stack direction="column" mb="auto" mt={{ md: 0, lg: "58px" }}>
        <Box ps="20px">
          <SidebarLinks routes={routes} activeId={activeId} />
        </Box>
      </Stack>

      <Box mt="60px" mb="40px" borderRadius="30px"></Box>
    </Flex>
  );
}

export default SidebarContent;
